import React, { Component } from "react";
import AntdInputNumber, { InputNumberProps } from "antd/lib/input-number";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/input-number/style";
import "@whalecloud/fdx-theme-fdx/input-number.less";

interface FINProps extends InputNumberProps {
  forwardedRef?: any;
}
class FdxInputNumber extends Component<FINProps> {
  render() {
    const { forwardedRef, ...rest } = this.props;
    return (
      <ConfigConsumer>
        {({ pagePoint }: ConfigConsumerEProps) =>
          pagePoint ? (
            <PagePoint
              compType="InputNumber"
              {...this.props}
              render={eventprops => (
                <AntdInputNumber ref={forwardedRef} {...rest} {...eventprops} data-ui-role="InputNumber" />
              )}
            ></PagePoint>
          ) : (
            <AntdInputNumber ref={forwardedRef} {...rest} />
          )
        }
      </ConfigConsumer>
    );
  }
}

const InputNumber = React.forwardRef((props: FINProps, ref) => {
  return <FdxInputNumber {...props} forwardedRef={ref} />;
});

export default InputNumber;



// WEBPACK FOOTER //
// ./src/components/input-number/index.tsx